var generateStyle = function generateStyle(componentTheme) {
  return {
    item: {
      position: 'relative',
      display: 'flex',
      marginBottom: componentTheme.itemMargin,
      alignItems: 'flex-start',
      marginTop: '1.5rem',
      '&:before': {
        width: '100%',
        top: "calc(".concat(componentTheme.itemBeforeMargin, " + 1rem)")
      },
      '> *': {
        flex: '0 1 100%',
        padding: componentTheme.itemPadding
      }
    },
    question: {
      marginTop: componentTheme.questionMargin,
      backgroundColor: componentTheme.questionColor,
      border: "".concat(componentTheme.questionBorder, " solid ").concat(componentTheme.questionBorderColor)
    },
    answer: {
      padding: 0,
      backgroundColor: 'white',
      marginRight: 0
    },
    divider: {
      padding: 0,
      flexShrink: '1.3',
      marginTop: "calc(".concat(componentTheme.dividerMargin, " * 1.6)"),
      borderBottom: "".concat(componentTheme.dividerBorder, " solid ").concat(componentTheme.dividerBorderColor)
    }
  };
};
export default generateStyle;